import { render, staticRenderFns } from "./AutotunerSelector.vue?vue&type=template&id=5147083d&scoped=true&"
import script from "./AutotunerSelector.vue?vue&type=script&lang=js&"
export * from "./AutotunerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5147083d",
  null
  
)

export default component.exports